"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_settings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "settings-mid"), /*#__PURE__*/React.createElement("g", {
    id: "d5ee3317-ff5b-4d3b-a546-be7363ccbddf",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fd40d512-3b01-4f61-9af5-4fcc916d5557",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af61ba0f-0899-410e-95f4-0110e3fc8b1b",
    "data-name": "<Pfad>",
    d: "M136.74,142.18,151,150.37a4,4,0,0,0,5.48-1.42L172,122.79a4,4,0,0,0-1.44-5.5l-16.23-9.35a57.83,57.83,0,0,0,.22-22.64L171,76.06a4,4,0,0,0,1.5-5.48L157.12,44.26a4,4,0,0,0-5.47-1.47L135.36,52a59.94,59.94,0,0,0-20-11.48V22a4,4,0,0,0-4-4H80.49a4,4,0,0,0-4,4V40.42a59.92,59.92,0,0,0-19.8,11.22l-16-9.2a4,4,0,0,0-5.48,1.42L19.62,70a4,4,0,0,0,1.44,5.5L37.15,84.8a57.81,57.81,0,0,0,0,22.52L21,116.41a4,4,0,0,0-1.5,5.48l15.33,26.31a4,4,0,0,0,5.47,1.47l16.37-9.23a59.94,59.94,0,0,0,19.75,11.18V170a4,4,0,0,0,4,4h30.9a4,4,0,0,0,4-4V151.56C123.83,150.23,131,147.14,136.74,142.18Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "5426576d-20d0-42c5-a43e-8a0e19201ebe",
    "data-name": "<Pfad>",
    d: "M125.94,94a30,30,0,1,1-28-28A30,30,0,0,1,125.94,94Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_settings;
exports.default = _default;